import { getDeviceInfo } from "helpers/utils";
import { getUserToken } from "../helpers/authHelper";
import api from "../api";

export async function FetchPendingList(payload) {
  return await api({
    method: "get",
    params: payload,
    url: `${process.env.REACT_APP_API_URL}/admin/pending/pending-list`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function FetchFilterInfo() {
  let lang_id = localStorage.getItem("lang_id");
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/common/getfilterdetails?language_id=${lang_id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function FetchResourcePoolFilters() {
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/job/getpoolfilters`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function fetchNextRoundData(payload) {
  return await api({
    method: "post",
    data: {
      ...payload,
      from_admin: true,
    },
    url: `${process.env.REACT_APP_API_URL}/admin/user/getrounddetails`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function sendBulkAssessment(payload) {
  let device_info = await getDeviceInfo(navigator);
  return await api({
    method: "post",
    data: { ...payload, device_info: device_info },
    url: `${process.env.REACT_APP_API_URL}/admin/job/sendbulkassessment`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function multiRoundStatusUpdate(payload) {
  let device_info = await getDeviceInfo(navigator);
  return await api({
    method: "post",
    data: { ...payload, device_info: device_info },
    url: `${process.env.REACT_APP_API_URL}/admin/job/roundstatusupdate`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function multiStatusUpdate(payload) {
  let device_info = await getDeviceInfo(navigator);
  return await api({
    method: "post",
    data: { ...payload, device_info: device_info },
    url: `${process.env.REACT_APP_API_URL}/admin/job/multistatusupdate`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function archiveApplication(payload) {
  let device_info = await getDeviceInfo(navigator);
  return await api({
    method: "post",
    data: { ...payload, device_info: device_info },
    url: `${process.env.REACT_APP_API_URL}/admin/job/archiveapplications`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function getFilteredList(payload) {
  return await api({
    method: "post",
    data: payload,
    url: `${process.env.REACT_APP_API_URL}/admin/common/getFilteredList`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function getApplicantPositionData(payload) {
  return await api({
    method: "post",
    data: payload,
    url: `${process.env.REACT_APP_API_URL}/admin/common/getapplvsposdetails`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function getFeedbackData() {
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/common/getfeedbackData`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}
export async function getCandidateFeedbackData() {
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/common/getcandidateFeedback`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}
export async function getPartialFormData({page, pageSize, queryText}) {
  console.log(page, pageSize, queryText)
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/pending/pending-job-list?page=${page}&pageSize=${pageSize}&queryText=${queryText}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function getCookieData() {
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/cookie/getcookieData`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function DeleteCookieRecord(id) {
  return await api({
    method: "put",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/cookie/delete-cookie/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function RejectPendingRecord(id) {
  return await api({
    method: "put",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/common/reject-application/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}
export async function updatestatus(
  appl_id,
  status,
  comment,
  status_change_from,
  remark_id,
  otherDetails
) {
  let authUser = JSON.parse(localStorage.getItem("authUser"));
  let user_id = authUser.user.id;
  let device_info = await getDeviceInfo(navigator);
  return await api({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/admin/common/update-status/${appl_id}`,
    data: {
      status,
      comment,
      user_id,
      status_change_from,
      device_info: device_info,
      remark_id,
      ...otherDetails,
    },
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function createfeedback(
  appl_id,
  status,
  comments,
  rating,
  round_id
) {
  let authUser = JSON.parse(localStorage.getItem("authUser"));
  let user_id = authUser.user.id;
  return await api({
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/admin/feedback/create-feedback`,
    data: { status, comments, user_id, appl_id, rating, round_id },
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function createtag(appl_id, tag) {
  console.log("createtag", tag);
  let authUser = JSON.parse(localStorage.getItem("authUser"));
  let user_id = authUser.user.id;
  return await api({
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/admin/tag/create-tag`,
    data: { appl_id, tag, user_id },
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function getAgencywiseApplicantData() {
  return await api({
    method: "get",
   // data: payload,
    url: `${process.env.REACT_APP_API_URL}/admin/candidate-details/getuserreport`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}